const initialState = {
  wishListLoading: true,
  wishList: [],
  query: {
    collectType: 1,
    page: 1,
    limit: 12,
  },
  total: 0,
};

function reducer(state, action) {
  switch (action.type) {
    case 'setWishListLoading':
      return { ...state, wishListLoading: action.payload };
    case 'setCategorys':
      return { ...state, categorys: action.payload };
    case 'setCategoryActive':
      return { ...state, categoryActive: action.payload };
    case 'setWishList':
      return { ...state, wishList: action.payload };
    case 'setQuery':
      return { ...state, query: action.payload };
    case 'setTotal':
      return { ...state, total: action.payload };
    default:
  }
}

const setWishListLoading = payload => ({
  type: 'setWishListLoading',
  payload
});

const setWishList = payload => ({
  type: 'setWishList',
  payload
});

const setQuery = payload => ({
  type: 'setQuery',
  payload
});

const setTotal = payload => ({
  type: 'setTotal',
  payload
});

export {
  initialState,
  reducer,
  setWishListLoading,
  setWishList,
  setQuery,
  setTotal
};
